import { Instance, SnapshotOut, types } from 'mobx-state-tree'
import { adminModel } from './models/admin'
import { customerDashboardModel } from './models/customerDashboard'
import { RegionStore, initialRegionState } from './models/location'
import { ContentModel, PropsInterface } from './models/styleModel'
import { supplierModel } from './models/supplier'
import { supplierDashboardModel } from './models/supplierDashboard'
import { userProfileModel } from './models/user'

export const RootStoreModel = types.model('RootStore').props({
  contentPages: types.optional(ContentModel, {} as any),
  properties: types.optional(types.array(PropsInterface), []),
  currentBlock: types.optional(PropsInterface, {}),
  userProfile: types.optional(userProfileModel, { id: 0 } as any),
  supplier: types.optional(supplierModel, { id: 0 } as any),
  supplierDashboard: types.optional(supplierDashboardModel, { id: 0 } as any),
  customerDashboard: types.optional(customerDashboardModel, { id: 0 } as any),
  admin: types.optional(adminModel, { id: 0 } as any),
  regions: types.optional(RegionStore, initialRegionState),
})

export interface RootStore extends Instance<typeof RootStoreModel> {}
export interface RootStoreSnapshot extends SnapshotOut<typeof RootStoreModel> {}
